import React, { useCallback } from 'react';
import { shallow } from 'zustand/shallow';

import { useSharePanelStore } from 'src/common/store/share.store';
import { IconButton } from 'src/common/icon-button';
import { LeftStrongIcon } from 'src/monet/icons';
export const ShareSlideoverBackButton = () => {
  const { popLinkConfigType } = useSharePanelStore(
    (state) => ({
      popLinkConfigType: state.popLinkConfigType,
    }),
    shallow
  );

  const onBackClicked = useCallback(() => {
    popLinkConfigType();
  }, [popLinkConfigType]);

  return (
    <div className='flex items-center space-x-sm'>
      <IconButton onClick={onBackClicked}>
        <LeftStrongIcon />
      </IconButton>
    </div>
  );
};
